import { Bookmark, Download, Layers, Loader2, Save, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DOCUMENT_TYPE_LABELS } from "./Exports.constants";

export default function FiltersPanel({
  typeFilter, setTypeFilter,
  statusFilter, setStatusFilter,
  signerFilter, setSignerFilter,
  shaPrefixFilter, setShaPrefixFilter,
  fromDateFilter, setFromDateFilter,
  toDateFilter, setToDateFilter,
  filteredCount, clearFilters,
  presets, presetName, setPresetName, presetBusy,
  applyPreset, deletePreset, saveCurrentAsPreset, exportPresets, importPresets,
}) {
  return (
    <div className="mt-4 grid gap-3 rounded-md border border-slate-200 bg-slate-50 p-4 md:grid-cols-3" data-testid="exports-filters-panel">
      <div className="space-y-1">
        <Label className="text-xs">Tipo documento</Label>
        <select className="h-9 w-full rounded-md border border-slate-200 bg-white px-3 text-sm" value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} data-testid="exports-type-filter">
          <option value="">Tutti</option>
          {Object.entries(DOCUMENT_TYPE_LABELS).map(([k, label]) => <option key={k} value={k}>{label}</option>)}
        </select>
      </div>
      <div className="space-y-1">
        <Label className="text-xs">Stato</Label>
        <select className="h-9 w-full rounded-md border border-slate-200 bg-white px-3 text-sm" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} data-testid="exports-status-filter">
          <option value="">Tutti</option>
          <option value="bozza">Bozza</option>
          <option value="finale">Finale</option>
          <option value="archiviato">Archiviato</option>
        </select>
      </div>
      <div className="space-y-1">
        <Label className="text-xs">Firmatario / autore</Label>
        <Input value={signerFilter} onChange={(e) => setSignerFilter(e.target.value)} placeholder="Match parziale" data-testid="exports-signer-filter" />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">SHA-256 prefisso (≥4 char)</Label>
        <Input value={shaPrefixFilter} onChange={(e) => setShaPrefixFilter(e.target.value)} placeholder="Es. 96b7c876" data-testid="exports-sha-filter" />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">Da</Label>
        <Input type="date" value={fromDateFilter} onChange={(e) => setFromDateFilter(e.target.value)} data-testid="exports-from-date-filter" />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">A</Label>
        <Input type="date" value={toDateFilter} onChange={(e) => setToDateFilter(e.target.value)} data-testid="exports-to-date-filter" />
      </div>
      <div className="md:col-span-3 flex justify-between">
        <p className="text-xs text-slate-500" data-testid="exports-filters-count">{filteredCount} risultati con i filtri attivi</p>
        <Button variant="outline" size="sm" onClick={clearFilters} data-testid="exports-filters-clear"><X className="h-4 w-4" /> Reset filtri</Button>
      </div>
      <div className="md:col-span-3 mt-2 space-y-2 rounded-md border border-blue-100 bg-blue-50/30 p-3" data-testid="exports-presets-section">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-blue-900"><Bookmark className="h-3.5 w-3.5" /> Preset salvati</p>
        <div className="flex flex-wrap gap-2" data-testid="exports-presets-list">
          {presets.length === 0 && <p className="text-xs text-slate-500">Nessun preset salvato per questo scope.</p>}
          {presets.map((p) => (
            <span key={p.id} className="inline-flex items-center gap-1 rounded-full border border-blue-200 bg-white px-3 py-1 text-xs" data-testid={`preset-chip-${p.id}`}>
              <button type="button" onClick={() => applyPreset(p)} className="font-medium text-blue-900 hover:underline" data-testid={`apply-preset-${p.id}`}>{p.name}</button>
              <button type="button" onClick={() => deletePreset(p)} className="text-red-600 hover:text-red-800" aria-label="Elimina preset" data-testid={`delete-preset-${p.id}`}><X className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <Input value={presetName} onChange={(e) => setPresetName(e.target.value)} placeholder="Nome preset (es. 'DVR finali questa settimana')" className="h-8 text-xs" data-testid="preset-name-input" />
          <Button size="sm" onClick={saveCurrentAsPreset} disabled={presetBusy || !presetName.trim()} className="bg-blue-900 hover:bg-blue-800" data-testid="save-preset-button">
            {presetBusy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Save className="h-3.5 w-3.5" />}
            Salva filtri correnti
          </Button>
          <Button size="sm" variant="outline" onClick={exportPresets} data-testid="export-presets-button"><Download className="h-3.5 w-3.5" /> Esporta JSON</Button>
          <label className="inline-flex h-8 cursor-pointer items-center gap-1 rounded-md border border-slate-200 bg-white px-3 text-xs font-medium hover:bg-slate-50" data-testid="import-presets-label">
            <Layers className="h-3.5 w-3.5" /> Importa JSON
            <input type="file" accept="application/json,.json" className="hidden" onChange={importPresets} data-testid="import-presets-input" />
          </label>
        </div>
      </div>
    </div>
  );
}
